import styles from './Section02.module.css';
import BlurText from '../Ui/BlurText';

function Section02() {
    return (
        <div className={styles.section02}>
            <div className={styles.section02Container}>
                <div className={styles.section02Content}>
                    <div className={styles.section02TextContainer}>
                        <BlurText className={styles.section02Title}
                            text="Branding Color is Brand Identity"
                            delay={150}
                            animateBy="words"
                            direction="top"
                        />
                        <p className={styles.section02SubTitle}>
                            세계적인 기업들은 컬러를 활용하여 브랜드를 차별화하고<br />
                            자신만의 이미지를 구축하여브랜드 가치를 향상시키고 있습니다.<br />
                            한국감성색채협회는 컬러를 전문적으로 연구하고 각 분야의 전문가들과 융합하여<br />
                            통합적인 관점에서 차별화 된 색채 팔레트 선정과 색채 전략을 제안합니다.
                        </p>
                        <p className={styles.mobileSection02SubTitle}>
                            세계적인 기업들은 컬러를 활용하여 브랜드를 차별화하고<br />
                            자신만의 이미지를 구축하여브랜드 가치를 향상시키고 있습니다.<br />
                            한국감성색채협회는 컬러를 전문적으로 연구하고<br />
                            각 분야의 전문가들과 융합하여 통합적인 관점에서<br />
                            차별화 된 색채 팔레트 선정과 색채 전략을 제안합니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Section02;

